import React from 'react';

const IconCheck: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3757 4.85181C20.7337 4.50703 21.3035 4.51778 21.6483 4.87582C21.993 5.23386 21.9823 5.80361 21.6243 6.14839L8.12425 19.1484C7.76703 19.4924 7.19886 19.4826 6.85372 19.1265L2.35372 14.4836C2.00778 14.1267 2.01668 13.5569 2.3736 13.211C2.73052 12.865 3.3003 12.8739 3.64624 13.2309L7.52189 17.2296L20.3757 4.85181Z"
      fill="currentColor"
    />
  </svg>
);

export default IconCheck;
